<template>
  <v-text-field
    dense
    v-model="mobileNum"
    :label="$t('label.mobileNumber')"
    outlined
    rounded
    class="stretch-append text-field-styling align-self-stretch"
    :error-messages="errorMessages"
    :rules="rules"
    @blur="$emit('blur')"
  >
    <template slot="prepend-inner">
      <v-menu tile bottom offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn link text tile v-bind="attrs" v-on="on" class="pa-0 my-auto primary--text" small :disabled="disableCountryCode">
            {{ selectedCountry.phone_code }}
            <v-icon v-if="!disableCountryCode">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense tile class="pa-0">
          <v-list-item v-for="country in countryList" :key="country.id" link active-class="primary--text text--lighten-1" @click="selectedCountry = country">
            <v-list-item-title>{{ country.phone_code }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: ['value', 'errorMessages', 'rules', 'disableCountryCode'],

  data() {
    return {
      selectedCountry: {
        id: this.value.country_id,
        phone_code: this.value.phone_code
      },
      mobileNum: this.value.mobile
    }
  },
  computed: {
    ...mapState('common', ['countryList']),
    fullMobileNum() {
      return {
        country_id: this.selectedCountry.id,
        phone_code: this.selectedCountry.phone_code,
        mobile: this.mobileNum
      }
    }
  },

  watch: {
    fullMobileNum(val) {
      this.$emit('input', val)
    }
  },

  async mounted() {
    await this.getCountryList()
    console.log('VALUE', this.value)
    this.selectedCountry = this.value ? this.value : this.countryList[0]
    console.log('SELECTED COUNTRY', this.selectedCountry)
  },

  methods: {
    ...mapActions('common', ['getCountryList'])
  }
}
</script>
